import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  template: '<router-outlet></router-outlet>',
})
export class SimpleLayoutComponent { }



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/containers/simple-layout/simple-layout.component.ts